import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { FormattedMessage } from "react-intl";

import { SrDialog, Typography } from "../../../common";

const useStyles = makeStyles({
  modalList: {
    listStyle: "none",
    paddingLeft: 0,
  },
});

const AvailableDialog = ({ isOpen, onClose }) => {
  const classes = useStyles();

  return (
    <SrDialog
      heading={<FormattedMessage id="balanceTitle" />}
      open={isOpen}
      handleClose={onClose}
    >
      <Typography>{<FormattedMessage id="balanceDescription1" />}</Typography>
      <Typography>{<FormattedMessage id="balanceDescription2" />}</Typography>
      <ul className={classes.modalList}>
        <li>{<FormattedMessage id="balanceVisaMasterCard" />}</li>
        <li>{<FormattedMessage id="balanceAmericanExpress" />}</li>
        <li>{<FormattedMessage id="balanceOxxo" />}</li>
        <li>{<FormattedMessage id="balanceSpei" />}</li>
      </ul>
    </SrDialog>
  );
};

export default AvailableDialog;
